import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "lowerCase",
  standalone: true,
})
export class LowerCasePipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (value) {
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
    return "";
  }
}
